var _ = require('underscore');
var Backbone = require('backbone');
var d3 = require('d3');
var Model = require('./model');
var Radio = require('backbone.radio');
var toolChannel = Radio.channel('tool');



var Collection = Backbone.Collection.extend({
	model: Model,
	// overview_data: {},
	initialize:function () {
		this.all_campuses    = [];
		this.tech_categories = [];
		this.circle_objects  = [];

		this.congressional_districts = [];
		this.congressional_districts_density = [];

		this.state_assembly_districts = [];
		this.state_assembly_districts_density	 =  [];

		this.state_senate_districts = [];
		this.state_senate_districts_density = [];

		this.county_districts = [];
		this.county_districts_density = [];

		this.formats();
		this.register_events();
	},

	register_events: function(){
		var collectionScope = this;
		toolChannel.on('startups:loaded', this.process_districts, collectionScope);
	},

  load: function(){
		var scope = this;

    d3.csv("data/uc_startups_03-02-2016.csv", function (data) {
      scope.process_data(data);
    });
  },

	// TODO: Clean up process_data()
	process_data: function (data) {
		for(var i=0; i<data.length;i++){

			var state = data[i].state;

			// only grab data for California
			if(state == "CA"){

				var campus     = data[i].campus;
				var tech_broad = data[i].tech_broad;

				this.all_campuses.push(campus);
				this.tech_categories.push(tech_broad);
				// money
				var revenue = (data[i].revenue === "") ? "$0" : data[i].revenue;
				var venture = (data[i].venture === "") ? "$0" : data[i].venture;
				var sbir = (data[i].sbir === "") 	  ? "$0" : data[i].sbir;


				revenue = revenue.replace(/,/gi, "");
				venture = venture.replace(/,/gi, "");
				sbir    = sbir.replace(/,/gi, "");


				revenue = parseInt(revenue.substr(1, revenue.length-1));
				venture = parseInt(venture.substr(1, venture.length-1));
				sbir = parseInt(sbir.substr(1, sbir.length-1));

				var total_revenue = revenue+venture+sbir;


				var employees = (data[i].employees === "") ? 0 : parseInt(data[i].employees);

				// get ids of US Congressional districts with UC startups
				var congressional_district_id = parseInt(data[i].congressional.substr(2, 4));

				// get ids of CA State Assembly districts with UC startups
				var state_assembly_district_id = parseInt(data[i].state_assembly.split(" ")[2]);

				// get ids of CA State Senate districts with UC startups
				var state_senate_district_id	= parseInt(data[i].state_senate.split(" ")[3]);

				// get county name, sans 'county'
				var county_link	= data[i].county.replace(" County", "").toLowerCase().replace(/ /gi, "-");

				// clean up incorp_data
				var year_incorp = data[i].date_incorp;
				if(year_incorp.length < 5 ){
					year_incorp = parseInt(data[i].date_incorp,10);
				}else{
					var date_incorp_str = data[i].date_incorp;
					year_incorp = parseInt(date_incorp_str.substr(date_incorp_str.length - 4),10);
				}

				data[i].is_active = this.isActiveStartup(data[i]);

				data[i].total_revenue = total_revenue;
				data[i].revenue_c = revenue;
				data[i].sbir_c = sbir;
				data[i].venture_c = venture;
				data[i].employees = employees;

				data[i].congressional_district_id = congressional_district_id;

				data[i].state_assembly_district_id = state_assembly_district_id;

				data[i].state_senate_district_id = state_senate_district_id;

				data[i].county_link = county_link;

				data[i].year_incorp = year_incorp;

				//var circle_o = {};


				// data for circular diagrams

				//var c_o = {};



				data[i].campus_link 		= "campus."+data[i].campus.replace(/ /gi, "").toLowerCase();

				data[i].city_link			= data[i].city.replace(/ /gi, "").toLowerCase();



				data[i].data_link 		= "campus."+data[i].campus.replace(/ /gi, "").toLowerCase();
				data[i].city_link 		= data[i].city.replace(/ /gi, "").toLowerCase();
				// data[i].tech_category 	= data[i].tech_broad.replace(/ /gi, "").toLowerCase() + "."+data[i].city_link;



				/* circle_o.campus = startup_data[i].campus;
				circle_o.campus_link = "campus."+startup_data[i].campus.replace(/ /gi, "").toLowerCase();
				circle_o.city   = startup_data[i].city;
				circle_o.city_link = startup_data[i].city.replace(/ /gi, "").toLowerCase();

				circle_o.money  = total_revenue;
				circle_o.tech  = startup_data[i].tech;
				circle_o.tech_category  = startup_data[i].tech_broad.replace(/ /gi, "").toLowerCase() + "."+circle_o.city_link;
				circle_o.tech_broad		= startup_data[i].tech_broad;

				circle_objects.push(circle_o); */

				// adding to the collection
				this.add(data[i]);

			}


		}

		this.all_campuses =  _.uniq(this.all_campuses);
		this.tech_categories =  _.uniq(this.tech_categories);

		// this.trigger("startups_loaded",{});
		toolChannel.trigger('startups:loaded');

	},

	/**
   * Loop through the collection and find the matching models based on where
   * the user has clicked
   */
  get_matching_data: function(collection, id, search_type) {
		var pattern = {};
		pattern[search_type] = id;

    return collection.where(pattern);
  },

	getMatchedAsColl: function(collection, id, search_type) {
		var matchedModelsColl = collection.filter(function (model) {
      return model.get(search_type) === id;
    });

		return new Collection(matchedModelsColl);
	},

	count_totals: function(matched, to_count) {
    var amount = 0;
    for (var i = 0; i < matched.length; i++) {
      var t = matched[i].get(to_count);
      amount += t;
    }
    return amount;
  },

	process_districts:function () {
		var collection = this.onlyActive();

		for(var i=0;i< collection.length;i++){

			var id = collection.at(i).get("congressional_district_id");
			var st_as_id = collection.at(i).get("state_assembly_district_id");
			var st_snt_id = collection.at(i).get("state_senate_district_id");
			var st_county_id = collection.at(i).get("county_link");

			if(!isNaN(id)){
				if(!this.congressional_districts[id]){
					this.congressional_districts[id] = [];
				}
				this.congressional_districts[id].push(id);
			}

			if(!isNaN(st_as_id)){
				if(!this.state_assembly_districts[st_as_id]){
					this.state_assembly_districts[st_as_id] = [];
				}
				this.state_assembly_districts[st_as_id].push(st_as_id);
			}

			if(!isNaN(st_snt_id)){
				if(!this.state_senate_districts[st_snt_id]){
					this.state_senate_districts[st_snt_id] = [];
				}
				this.state_senate_districts[st_snt_id].push(st_snt_id);
			}

			if( st_county_id ){
				if(!this.county_districts[st_county_id]){
					this.county_districts[st_county_id] = [];
				}
				this.county_districts[st_county_id].push(st_county_id);
			}


			// if(!this.county_districts[st_county_id]){
			// 	this.county_districts[st_county_id] = [];
			// }
			// this.county_districts[st_county_id].push(st_county_id);
		}

		this.set_density();


		toolChannel.trigger('startups:density:done');
	},

	set_density: function(){
		this.congressional_districts_density 	= this.calculate_density(this.congressional_districts);
		this.state_assembly_districts_density 	= this.calculate_density(this.state_assembly_districts);
		this.state_senate_districts_density 	= this.calculate_density(this.state_senate_districts);
		this.county_districts_density = this.calculate_density(this.county_districts);
	},

	// Number of Startups per district
	calculate_density:function (districts) {
		var districts_count = [];
		for(var k in districts){
			districts_count[k] = districts[k].length;
		}
		return districts_count;
	},

	formats: function(){
		this.formatNumber = d3.format(".lf");
		this.formatCommas = d3.format(",");
		this.formatPercent = d3.format("%");
		this.formatCurrency = d3.format("$,.2f");
		this.formatCurrencyNoCents = d3.format("$,");
	},

	formatBigCurrency: function(d) {
		var s = "$";
		if (d > 999999999) {
			s += Number( parseFloat(this.formatNumber(d/1e9)).toFixed(1)) + " billion";
		} else if (d > 999999) {
			s += Number( parseFloat(this.formatNumber(d/1e6)).toFixed(1)) + " million";
		} else {
			s += this.formatCommas(d);
		}
		return s;
	},

	// Check if a startup model counts as "active"
	isActiveStartup: function(startup){
		return (
			startup.current_status === 'Active' ||
			startup.current_status === 'Not Yet Commercialized' ||
			startup.current_status === 'Acquired as Subsidiary'
		);
	},

	onlyActive: function (){
    filtered = this.filter(function (startup) {
      return startup.get("is_active") === true;
    });
    return new Collection(filtered);
  }

});
module.exports = Collection;
